import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_CASH, STR_FLOAT, STR_PENDING, STR_PROCESSED, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_REJECTED, STR_SUBSCRIPTION_HAS_EXPIRED, STR_YOUR_REQUEST } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";

export default function OneFloatLoan({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "side-view",
			subItem: "float-loan",
			extraItem: data.id,
		});
	}

	function getStatus() {
		if(data) {
			let status = 'pending';

			if(data.isRejected === 'no' && data.isLoaned === 'no') {
				status = 'pending';
			} else if(data.isRejected === 'yes') {
				status = 'rejected';
			} else if(data.isLoaned === 'yes') {
				status = 'processed';
			}

			return status;
		}
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
			}}
		>
			
			<span 
				className={(getStatus() === 'processed') ? "badge bg-success" : "badge bg-dark"}
			>
				{(getStatus() === 'pending') ? STR_PENDING[appContext.language] : ''}
				{(getStatus() === 'processed') ? STR_PROCESSED[appContext.language] : ''}
				{(getStatus() === 'rejected') ? STR_REJECTED[appContext.language] : ''}
			</span>

			<h6
				style={{
					fontSize: "20px",
				}}
				className="font-semi-bold"
			>
				TZS {formatMoney(data.amountRequested)}
			</h6>

			<h6
				style={{
					fontSize: "18px"
				}}
			>
				{appContext.getTillTypeName(JSON.parse(data.till).tillType)}
			</h6>

			

			<div className="text-end">
				<h6
					className="font-regular"
					style={{
						fontSize: "12px"
					}}
				>
					{formatDate(data.dateCreated)}
				</h6>
			</div>

			<hr/>
		</div>
	);
}
